import _ from 'lodash'

export function getValueByType(types, type) {
  return _.invert(types)[type]
}